import React from "react";
import "./TopBar.css";
import { translations } from "../i18n";

export type LangCode = "es" | "en" | "fr" ;

const LANG_LABELS: Record<LangCode, string> = {
  es: "Español",
  en: "English",
  fr: "Français",
};

interface TopBarProps {
  currentLang: LangCode;
  onChangeLang: (lang: LangCode) => void;
}

const TopBar: React.FC<TopBarProps> = ({ currentLang, onChangeLang }) => {
  const label = LANG_LABELS[currentLang] || "Español";
  const t = translations[currentLang];

  const handleClick =
    (code: LangCode) => (e: React.MouseEvent<HTMLButtonElement>) => {
      onChangeLang(code);
      const details = e.currentTarget.closest("details") as
        | HTMLDetailsElement
        | null;
      if (details) details.open = false;
    };

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header className="header">
      <div className="container header__inner">
        {/* Logo */}
        <a href="/" className="brand--logo" aria-label="BoxFlow">
          <div className="logo-container">
            <img src="/logo.svg" alt="BoxFlow logo" className="logo-img" />
          </div>
        </a>

        {/* Right side: nav + language selector */}
        <div className="header-right">
          <nav className="nav">
            <button
              type="button"
              className="nav-btn"
              onClick={() => scrollToSection("servicios")}
            >
              {t.nav.services}
            </button>
            <button
              type="button"
              className="nav-btn"
              onClick={() => scrollToSection("opiniones")}
            >
              {t.nav.reviews}
            </button>
          </nav>

          <details className="lang-dropdown">
            <summary
              className="lang-toggle"
              aria-label={`Cambiar idioma (actual: ${label})`}
            >
              {label}
              <span className="lang-caret">▾</span>
            </summary>
            <div className="lang-menu">
              <button
                type="button"
                className={`lang-btn ${
                  currentLang === "es" ? "lang-btn--active" : ""
                }`}
                data-lang="es"
                onClick={handleClick("es")}
              >
                Español
              </button>
              <button
                type="button"
                className={`lang-btn ${
                  currentLang === "en" ? "lang-btn--active" : ""
                }`}
                data-lang="en"
                onClick={handleClick("en")}
              >
                English
              </button>
              <button
                type="button"
                className={`lang-btn ${
                  currentLang === "fr" ? "lang-btn--active" : ""
                }`}
                data-lang="fr"
                onClick={handleClick("fr")}
              >
                Français
              </button>
            </div>
          </details>
        </div>
      </div>
    </header>
  );
};

export default TopBar;